<template>
	<section
		ref="resizableContainerRef"
		class="resize-container flex"
		:class="{ 'flex-col': horizontal }"
	>
		<article
			class="slot w-full h-full overflow-auto relative"
			:class="{ close: close }"
		>
			<slot />
		</article>

		<aside
			class="bg-gray-800 max-lg:hidden resize-bar cursor-ew-resize flex justify-center items-center flex-1 min-w-[3px] min-h-[3px] relative"
			:class="{ '!cursor-ns-resize': horizontal }"
		>
			<div v-if="!horizontal" @click="close = !close">
				<i
					:class="{
						'bi-chevron-left -translate-x-[8px]': !close,
						'bi-chevron-right -translate-x-[4px]': close,
					}"
					class="bg-tertiary p-1 !px-0.5 rounded-md border border-secondary border-solid cursor-pointer z-[1] absolute"
				></i>
			</div>
			<div v-if="horizontal" @click="close = !close">
				<i
					:class="{
						'bi-chevron-up -translate-y-[8px]': !close,
						'bi-chevron-down -translate-y-[4px]': close,
					}"
					class="bg-tertiary p-1.5 py-0 rounded-md border border-secondary border-solid cursor-pointer z-[1] absolute"
				></i>
			</div>
		</aside>
	</section>
</template>

<script>
export default {
	name: "ResizableElement",
	props: {
		horizontal: Boolean,
		container: HTMLElement,
	},
	data() {
		return {
			resize: null,
			slot: null,
			moveX: 0,
			moveY: 0,
			drag: false,
			close: false,
		};
	},
	watch: {
		container() {
			if (!this.container) return;

			this.setMouseMove(this.container);
			this.setMouseUp(this.container);
		},
	},
	mounted() {
		this.resize = this.$refs.resizableContainerRef.querySelector(".resize-bar");
		this.slot = this.$refs.resizableContainerRef.querySelector(".slot");

		this.moveX =
			this.slot.getBoundingClientRect().width +
			this.resize.getBoundingClientRect().width / 2;

		this.moveY =
			this.slot.getBoundingClientRect().height +
			this.resize.getBoundingClientRect().height / 2;

		this.resize.addEventListener(
			"mousedown",
			function (e) {
				this.$emit("resize-start");
				this.drag = true;

				this.moveX = e.x;
				this.moveY = e.y;

				document.body.classList.add("select-none");
			}.bind(this)
		);

		this.setMouseMove(document.body);
		this.setMouseUp(document.body);
	},
	methods: {
		setMouseMove(container) {
			container.addEventListener(
				"mousemove",
				function (e) {
					if (this.close) return;
					if (!this.drag) return;

					this.moveX = e.x;
					this.moveY = e.y;

					if (this.horizontal) {
						this.slot.style.height =
							this.moveY -
							this.slot.offsetTop -
							this.resize.getBoundingClientRect().height / 2 +
							"px";
						return;
					}

					this.slot.style.width =
						this.moveX -
						this.slot.offsetLeft -
						this.resize.getBoundingClientRect().width / 2 +
						"px";
				}.bind(this)
			);
		},
		setMouseUp(container) {
			container.addEventListener(
				"mouseup",
				function () {
					this.$emit("resize-end");
					this.drag = false;
					document.body.classList.remove("select-none");
				}.bind(this)
			);
		},
	},
};
</script>

<style scoped>
.close {
	max-width: 0px !important;
	max-height: 0px !important;
	transition: all 0.3s ease;
}
</style>
